import PermissionsService, {
  PERMISSION_RIDE_INFO_TAGS_ASSIGMENT,
  PERMISSION_PERIOD_LOCK_ADMIN,
  PERMISSION_RIDE_DRIVER_ASSIGNMENT,
  PERMISSION_RIDE_INFO_COMMENT_ASSIGNMENT,
  PERMISSION_RIDE_POSITIONS,
  PERMISSION_RIDE_PRIVACT_SETUP,
  PERMISSION_RIDE_SHOW_AND_PLAY,
  PERMISSION_NEW_RIDE,
} from '../../Services/PermissionsService';
import { IS_DRIVER } from '../Employee/EmployeeService';
import { ITripsOverViewRecord } from './interfaces';
import {
  CHANGE_DRIVER_ACTION,
  IS_COMMENT,
  IS_MANUAL_RIDE,
  IS_TAG,
  PARKING_COMMENT_ACTION,
  PARKING_PURPOSE_ACTION,
  RIDE_COMMENT_ACTION,
  RIDE_PURPOSE_ACTION,
  SHOW_RIDE_ACTION,
  TYPE_PRIVATE_ACTION,
  TYPE_PUBLIC_ACTION,
} from './constants';

const IS_LOCKED = 'locked';
const IS_RESTRICTED = 'restricted';
const IS_PRIVACY = 'privacy';

const getIsRideLocked = (locked: string, customerIds: number[], type: string) => {
  if (locked === IS_LOCKED) {
    return true;
  }
  if (locked === IS_RESTRICTED) {
    return !PermissionsService.hasAccess(PERMISSION_PERIOD_LOCK_ADMIN, [type], customerIds);
  }
  return false;
};

const TripsOverviewActions = {
  getAllowedActions(data: ITripsOverViewRecord): string[] {
    const actions: string[] = [];
    if (
      !getIsRideLocked(data.locked || '', [data.customer.id], 'create') &&
      PermissionsService.hasAccess(
        PERMISSION_RIDE_INFO_TAGS_ASSIGMENT,
        ['create'],
        data.customer.id
      )
    ) {
      actions.push('tag');
    }
    if (
      !getIsRideLocked(data.locked || '', [data.customer.id], 'create') &&
      data &&
      data.info.summary.comment === 0 &&
      PermissionsService.hasAccess(
        PERMISSION_RIDE_INFO_COMMENT_ASSIGNMENT,
        ['create'],
        data.customer.id
      )
    ) {
      actions.push(IS_COMMENT);
    }
    if (
      !getIsRideLocked(data.locked || '', [data.customer.id], 'update') &&
      PermissionsService.hasAccess(PERMISSION_RIDE_DRIVER_ASSIGNMENT, ['update'], data.customer.id)
    ) {
      actions.push(IS_DRIVER);
    }
    if (
      !getIsRideLocked(data.locked || '', [data.customer.id], 'update') &&
      PermissionsService.hasAccess(PERMISSION_RIDE_PRIVACT_SETUP, ['update'], data.customer.id)
    ) {
      actions.push(IS_PRIVACY);
    }
    if (
      PermissionsService.hasAccess(PERMISSION_RIDE_SHOW_AND_PLAY, ['read'], data.customer.id) &&
      Number(data.positionCount.replace(',', '.')) > 0
    ) {
      actions.push('show');
    }
    if (
      PermissionsService.hasAccess(PERMISSION_RIDE_POSITIONS, ['read'], data.customer.id) &&
      Number(data.positionCount.replace(',', '.')) > 0
    ) {
      actions.push('detail');
    }

    if (
      PermissionsService.hasAccess(PERMISSION_NEW_RIDE, ['update'], data.customer.id) &&
      (data.source === IS_MANUAL_RIDE || data.source === IS_MANUAL_RIDE)
    ) {
      actions.push('new-ride');
    }
    if (
      PermissionsService.hasAccess(PERMISSION_NEW_RIDE, ['delete'], data.customer.id) &&
      (data.source === IS_MANUAL_RIDE || data.source === IS_MANUAL_RIDE)
    ) {
      actions.push('remove-ride');
    }
    return actions;
  },

  getAllowedParkingActions(data: ITripsOverViewRecord): string[] {
    const isParkingFinished = data.parking?.id;
    const parkingWithoutComment = data.parking && data.parking.summary.comment === 0;
    const parkingActions: string[] = [];
    if (
      !getIsRideLocked(data.locked || '', [data.customer.id], 'create') &&
      data.parking &&
      PermissionsService.hasAccess(
        PERMISSION_RIDE_INFO_TAGS_ASSIGMENT,
        ['create'],
        data.customer.id
      ) &&
      isParkingFinished
    ) {
      parkingActions.push(IS_TAG);
    }
    if (
      !getIsRideLocked(data.locked || '', [data.customer.id], 'create') &&
      PermissionsService.hasAccess(
        PERMISSION_RIDE_INFO_COMMENT_ASSIGNMENT,
        ['create'],
        data.customer.id
      ) &&
      parkingWithoutComment &&
      isParkingFinished
    ) {
      parkingActions.push(IS_COMMENT);
    }
    return parkingActions;
  },

  getIcon(id: string): string {
    switch (id) {
      case RIDE_PURPOSE_ACTION:
        return 'single-folded-content-add';
      case RIDE_COMMENT_ACTION:
        return 'comment-add';
      case CHANGE_DRIVER_ACTION:
        return 'single-user';
      case TYPE_PRIVATE_ACTION:
        return 'shifting-mode-private';
      case TYPE_PUBLIC_ACTION:
        return 'ride-mode-work';
      case SHOW_RIDE_ACTION:
        return 'play-simple';
      case PARKING_PURPOSE_ACTION:
        return 'single-folded-content-add';
      case PARKING_COMMENT_ACTION:
        return 'comment-add';
      default:
        return 'single-folded-content-add';
    }
  },
};
export default TripsOverviewActions;
